/**
 * Get previous slide index depending on current slide index
 */
export const getIsPreviousSlide = ({
	i,
	currentRealIndex,
	items,
	offset = 1,
}) => {
	if (currentRealIndex - offset < 0) {
		return items.length - currentRealIndex - offset === i % items.length;
	} else {
		return currentRealIndex - offset === i % items.length;
	}
};
